module.exports = __webpack_public_path__ + "static/media/noClaim.58c9dda6.svg";